import FragmentMixin from 'client-portal/serializers/-fragment';
import classic from 'ember-classic-decorator';

@classic
export default class GoodFaithEstimateService extends FragmentMixin {}
